import type { StoreActionApi } from 'react-sweet-state';
import { INITIAL_UI_STATE } from '../../../../common/constants/state';
import type { CancelModalState, UIState } from '../../../../common/types';

export const setIsCancelImportModalOpen =
	(isCancelImportModalOpen: boolean) =>
	({ setState, getState }: StoreActionApi<UIState>) => {
		setState({ cancelModal: { ...getState().cancelModal, isCancelImportModalOpen } });
	};

export const setCancelImportModalState =
	(cancelImportModalState: Partial<CancelModalState>) =>
	({ setState, getState }: StoreActionApi<UIState>) => {
		setState({ cancelModal: { ...getState().cancelModal, ...cancelImportModalState } });
	};

export const resetCloseModalImportState =
	() =>
	({ setState }: StoreActionApi<UIState>) => {
		setState({ cancelModal: INITIAL_UI_STATE.cancelModal });
	};
